module.exports = __webpack_public_path__ + "img/111.8c2ca963.png";